module.exports = __webpack_public_path__ + "static/assets/2e6dc65ff7ecfc7e71b5ba88a782606f.png";